declare let __webpack_nonce__: string;

const DEV_CSP_NONCE = 'dev-csp-nonce';
const CSP_NONCE_PLACEHOLDER = '__NAUTO_CSP_NONCE__';

const getRuntimeNonce = (): string => {
  if (typeof window !== 'undefined') {
    const windowNonce = (window as any).__NAUTO_CSP_NONCE__;
    if (typeof windowNonce === 'string' && windowNonce) {
      return windowNonce;
    }
  }

  if (typeof document !== 'undefined') {
    const metaNonce = document
      .querySelector('meta[name="nauto-csp-nonce"]')
      ?.getAttribute('content');

    if (metaNonce && metaNonce !== CSP_NONCE_PLACEHOLDER) {
      return metaNonce;
    }
  }

  return DEV_CSP_NONCE;
};

const applyNonceToDynamicElements = (nonce: string) => {
  if (typeof document === 'undefined') {
    return;
  }

  const scopedDocument = document as Document & {
    __cspNoncePatched__?: boolean;
  };
  if (scopedDocument.__cspNoncePatched__) {
    return;
  }

  const applyNonce = (node: Node) => {
    const element = node as Element;
    if (!element?.tagName) {
      return node;
    }

    const normalizedTagName = element.tagName.toLowerCase();
    if (
      (normalizedTagName === 'style' || normalizedTagName === 'script') &&
      !(element as HTMLElement).getAttribute('nonce')
    ) {
      (element as HTMLElement).setAttribute('nonce', nonce);
    }

    return node;
  };

  const applyNonceToHtml = (html: string) =>
    html
      .replace(/<style(\s[^>]*)?>/gi, (fullMatch, attrs = '') =>
        /\bnonce\s*=/.test(attrs)
          ? fullMatch
          : `<style${attrs} nonce="${nonce}">`,
      )
      .replace(/<script(\s[^>]*)?>/gi, (fullMatch, attrs = '') =>
        /\bnonce\s*=/.test(attrs)
          ? fullMatch
          : `<script${attrs} nonce="${nonce}">`,
      );

  const createElement = document.createElement.bind(document) as (
    tagName: string,
    ...args: unknown[]
  ) => HTMLElement;
  document.createElement = ((tagName: string, ...args: unknown[]) => {
    const element = createElement(tagName, ...args);
    return applyNonce(element) as HTMLElement;
  }) as typeof document.createElement;

  const insertAdjacentHTML = Element.prototype.insertAdjacentHTML;
  Element.prototype.insertAdjacentHTML = function(
    position: InsertPosition,
    text: string,
  ): void {
    insertAdjacentHTML.call(this, position, applyNonceToHtml(text));
  };

  const innerHTMLDescriptor = Object.getOwnPropertyDescriptor(
    Element.prototype,
    'innerHTML',
  );
  if (innerHTMLDescriptor?.set && innerHTMLDescriptor.get) {
    Object.defineProperty(Element.prototype, 'innerHTML', {
      configurable: true,
      enumerable: innerHTMLDescriptor.enumerable,
      get: innerHTMLDescriptor.get,
      set(value: unknown) {
        innerHTMLDescriptor.set?.call(this, applyNonceToHtml(String(value)));
      },
    });
  }

  scopedDocument.__cspNoncePatched__ = true;
};

const cspNonce = getRuntimeNonce();

if (cspNonce) {
  __webpack_nonce__ = cspNonce;
  if (typeof globalThis !== 'undefined') {
    (globalThis as any).__webpack_nonce__ = cspNonce;
  }
  if (typeof window !== 'undefined') {
    (window as any).__webpack_nonce__ = cspNonce;
  }
  applyNonceToDynamicElements(cspNonce);
}

import('./index');
